import axios from "axios";

export default function generateDi(uuid) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/distributor/admin/api/v1/shipping-order/generate-di`, {
        shipping_order_uuid: uuid,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
